module.exports = __webpack_public_path__ + "img/people.0256c26a.svg";